import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { authState } from "@atoms/authState";
import { getUserBaseRoute } from "@utils/auth";

/**
 * SpaceGuard - Composant de sécurité qui vérifie que l'utilisateur
 * accède uniquement à son espace autorisé.
 *
 * Empêche un utilisateur "company" d'accéder à "/pool/..." en changeant l'URL manuellement par exemple.
 * Redirige automatiquement vers l'espace autorisé de l'utilisateur.
 */
const SpaceGuard = ({ allowedSpace, children }) => {
  const authValue = useRecoilValue(authState);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!authValue?.user) return;

    const userSpace = getUserBaseRoute(authValue);

    if (!userSpace) {
      console.error(
        `[SpaceGuard] Espace non reconnu pour le rôle "${authValue?.user?.user_role}". Redirection vers la connexion...`
      );
      navigate("/connexion", { replace: true });
      return;
    }

    if (userSpace !== allowedSpace) {
      console.warn(
        `[SpaceGuard] Accès non autorisé: utilisateur "${userSpace}" tente d'accéder à "/${allowedSpace}". Redirection...`
      );
      navigate(`/${userSpace}/dashboard`, { replace: true });
    }
  }, [authValue, allowedSpace, navigate, location.pathname]);

  const userSpace = getUserBaseRoute(authValue);

  // Espace non reconnu - afficher page d'erreur
  if (authValue?.user && !userSpace) {
    return (
      <div style={{ padding: "2rem", textAlign: "center" }}>
        <h2>Espace non reconnu</h2>
        <p>Votre rôle utilisateur n'est pas associé à un espace valide.</p>
        <p>Veuillez contacter l'administrateur.</p>
        <button
          onClick={() => navigate("/connexion", { replace: true })}
          style={{
            marginTop: "1rem",
            padding: "0.5rem 1rem",
            cursor: "pointer",
          }}
        >
          Retour à la connexion
        </button>
      </div>
    );
  }

  if (authValue?.user && userSpace && userSpace !== allowedSpace) {
    return null;
  }

  return children;
};

export default SpaceGuard;
